export const CONFIG = {
    small: 24,
    medium: 32,
    large: 40,
};
